import Widget from "../../lib/ui/Widget";
import { C } from "../../lib/ui/constructors";
var cls = C.cls;
export class Notification {
    constructor() {
        this._type = "information";
        this._duration = 3000;
        this.hasDismiss = true;
        this.options = [];
        this._content = c();
    }
    show(bar = undefined) {
        if (!bar)
            bar = NotificationBar.instance();
        bar.do(this);
    }
    render(instance) {
        const widget = cls("ctr-notification");
        widget
            .addClass(`ctr-notification-${this._type ?? "information"}`);
        const body = cls("ctr-notification-content")
            .append(this._content)
            .appendTo(widget);
        for (let option of this.options) {
            const content = typeof option.content == "string"
                ? cls("ctr-notification-link").append(option.content)
                : option.content;
            body.append(cls("ctr-notification-spacer"), content.on("click", () => {
                option.handler(instance);
            }));
        }
        if (this.hasDismiss) {
            body.append(cls("ctr-notification-spacer"), c("<div class='ctr-notification-dismiss'>&times;</div>")
                .tooltip("Dismiss")
                .on("click", () => instance.dismiss()));
        }
        return widget;
    }
    setType(type) {
        this._type = type;
        return this;
    }
    addButton(text, handler = () => { }) {
        this.options.push({
            content: text,
            handler: handler
        });
        return this;
    }
    /**
     * @param duration Timeout duration in milliseconds
     */
    setDuration(duration) {
        this._duration = duration;
        return this;
    }
    setContent(content) {
        this._content = content;
        return this;
    }
}
export class NotificationInstance {
    constructor(original, bar) {
        this.original = original;
        this.bar = bar;
        this.widget = original.render(this);
    }
    dismiss(fade = false) {
        if (fade)
            this.widget.container.fadeOut(300, () => this.widget.remove());
        else
            this.widget.remove();
    }
}
(function (Notification) {
    function notification(content, type = "information") {
        return new Notification().setContent(content).setType(type);
    }
    Notification.notification = notification;
})(Notification || (Notification = {}));
export class NotificationBar extends Widget {
    constructor() {
        super();
        this.addClass("ctr-notification-bar");
    }
    do(notification) {
        const instance = new NotificationInstance(notification, this);
        instance.widget
            .css("display", "none")
            .appendTo(this)
            .container.animate({
            "height": "toggle"
        }, 300);
        if (notification._duration != null) {
            setTimeout(() => {
                instance.dismiss(true);
            }, notification._duration);
        }
        return this;
    }
    static instance() {
        if (!this._instance)
            this._instance = new NotificationBar();
        return this._instance;
    }
}
NotificationBar._instance = null;
